import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./ts-store";
import Axios from "axios";
import VueTour from "vue-tour";
import shared from './sharedMethods';
require("./styles/vue-tour.css");

import "./quasar";
import "animate.css";
/*
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

 Sentry.init({
  Vue,
  dsn: "https://a2a95a3f5b9143f4a30df4014d5303b0@o516673.ingest.sentry.io/5623399",
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
}); */

Vue.use(VueTour);

Vue.config.productionTip = false;

// set auth header
Axios.defaults.headers.common["Authorization"] = `${store.state.token}`;
Axios.interceptors.response.use(
	(response) => response,
	(error) => {
		// If backend is offline you get a Network Error
		if (error.message === 'Network Error') {
			shared.errorNotify('Connection problem detected. Possibly the server is not reachable. Please try again later.');
		}
		// If your token is expired you get a 401 response from server
		if (error.response && error.response.status === 401 && router.currentRoute.path !== "/login") {
			store.dispatch("logout");
			router.push("/login");
		}
		return Promise.reject(error.response);
	}
);

new Vue({
	router,
	store,

	render: (h) => h(App),
}).$mount("#app");
